import { api } from "@/redux/api";

import {
	WebsiteScrapeSchema,
	WebsiteScrape,
} from "@/pages/Private/pages/Usage/schema/websiteScrape";

import {
	CreateStripeCheckoutSession,
	FinalizeStripeCheckoutSession,
	FinalizeStripeCheckoutSessionResponse,
	CreateStripeCheckoutSessionResponse,
} from "../../pages/Subscription/schema/stripe-checkout-session";

export const websiteScrapeApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getWebsiteScrapeCredits: builder.query<WebsiteScrape, void>({
			query: () => ({
				url: "websiteScrape",
				responseSchema: WebsiteScrapeSchema,
			}),
			providesTags: ["WebsiteScrape"],
		}),
		createCheckoutSessionForWebsiteScrape: builder.mutation<
			CreateStripeCheckoutSessionResponse,
			CreateStripeCheckoutSession
		>({
			query: (body) => ({
				url: "websiteScrape/create-checkout-session",
				method: "POST",
				body,
			}),
		}),
		finalizeCheckoutSessionForWebsiteScrape: builder.mutation<
			FinalizeStripeCheckoutSessionResponse,
			FinalizeStripeCheckoutSession
		>({
			query: (body) => ({
				url: "websiteScrape/finalize-checkout-session",
				method: "POST",
				body,
			}),
			invalidatesTags: ["Me", "WebsiteScrape"],
		}),
	}),
});

export const {
	useGetWebsiteScrapeCreditsQuery,
	useCreateCheckoutSessionForWebsiteScrapeMutation,
	useFinalizeCheckoutSessionForWebsiteScrapeMutation,
} = websiteScrapeApi;
export const websiteScrapeApiReducer = websiteScrapeApi.reducer;
export const websiteScrapeApiMiddleware = websiteScrapeApi.middleware;
